export default "__VITE_PUBLIC_ASSET__10cb372f__"